import {
  StringMatchOperator,
  stringMatchOperatorToLabel,
} from "@redotech/redo-flows-core-schema-common/expressions/text-expression";
import { Text } from "@redotech/redo-web/text";

export function StringMatchDetails({
  field,
  matchType,
  matchValue,
}: {
  field: string;
  matchType?: StringMatchOperator;
  matchValue?: string;
}) {
  return (
    <>
      <Text fontWeight="semibold">{field}</Text>{" "}
      <Text>
        {matchType ? ` ${stringMatchOperatorToLabel[matchType]} ` : undefined}
      </Text>{" "}
      <Text
        fontWeight="semibold"
        style={{
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        "{matchValue}"
      </Text>
    </>
  );
}
